import { useState, useEffect } from "react";
import { GUID_REGEX } from "@/utils/constants";
import { STATUS } from "@/utils/enum";
import { getSecurePassLogs } from "@/services/secure_pass";

export default function useSecurePassLogs(shipmentId, logType) {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(STATUS.IDLE);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    setStatus(STATUS.LOADING);

    if (!shipmentId || !GUID_REGEX.test(shipmentId)) {
      setStatus(STATUS.ERROR);
      setError("Missing shipment ID");
      setData([]);
      return;
    }

    const fetchData = async () => {
      try {
        const response = await getSecurePassLogs({
          filter: shipmentId,
          securePassLogType: logType,
          page: 1,
          pageSize: 100,
        });

        setData(response?.items ?? []);
        setStatus(STATUS.SUCCESS);
      } catch (error) {
        console.error(error);
        setStatus(STATUS.ERROR);
        setError("Failed to fetch secure pass logs");
        setData([]);
      }
    };

    fetchData();
  }, [shipmentId, logType, refreshKey]);

  const refreshData = () => {
    setRefreshKey(prev => prev + 1);
  };

  return { data, status, error, refreshData };
}
